import { AxiosError } from "axios";

import { CartItem } from "custom-types/Cart";

type AxiosErrorMetaData = {
  cartItems?: Partial<CartItem>;
  reason?: string;
};

export class ReservationsApiError extends Error {
  title: string;
  detail: string;
  // metadata is only provided for Axios errors
  metadata: AxiosErrorMetaData | null;
  reason: string | null;
  constructor({
    message = "There was an error while placing the order",
    metadata = null,
    title = "",
    detail = "",
  }) {
    super(message);
    this.title = title;
    this.detail = detail;
    this.metadata = metadata;
    this.reason =
      (metadata as AxiosErrorMetaData | null)?.reason ||
      detail
        ?.split(" ")
        .find((s) => s.includes("reason="))
        ?.replace("reason=", "") ||
      null;
  }
}

export class ApiOgServiceError extends Error {
  url: string | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  status: any;
  constructor(axiosResponse: AxiosError, message: string) {
    const { config: { url } = {}, response: { status, statusText } = {} } =
      axiosResponse;

    super(message || statusText);
    this.url = url;
    this.status = status || 500;
  }
}

export class ComplianceServiceError extends Error {
  url: string | undefined;
  status: number;
  constructor(axiosResponse: AxiosError, message: string) {
    const { config: { url } = {}, response: { status, statusText } = {} } =
      axiosResponse;

    super(message || statusText);
    this.url = url;
    this.status = status || 500;
  }
}
